import { Box, Title } from '@holbonkit/ui'

import styles from './progress-bar.module.scss'

type TProgressBarProps = {
    currentStep: number
    totalSteps: number
}

export const ProgressBar = ({ currentStep, totalSteps }: TProgressBarProps) => {
    return (
        <Box className={styles['progress-bar']} pb={4} px={4}>
            <Title as='span' variant='header-20-bold'>
                {currentStep} из {totalSteps}
            </Title>
            <Box className={styles['progress-container']}>
                <Box
                    className={styles['progress-fill']}
                    style={{ width: `${(currentStep / totalSteps) * 100}%` }}
                />
            </Box>
        </Box>
    )
}
